export enum SortOrder {
  Unknown = 'U',
  Ascending = 'A',
  Descending = 'D'
}
